import {Menu, MenuItem} from '@material-ui/core'
import React, {useMemo, useContext} from 'react'
import {ReservationContext} from '../../context/Reservation'
import useCalendarViewContext from '../../context/CalendarView'
import {SettingsContext} from '../../context/Settings/Settings'
import {Tooltip} from '@material-ui/core'
import useGetReservationItemDetails from '../../state/get-reservation-item-details/reducer'

const MenuMore = ({
  onClickEdit = e => {},
  onClickDelete = e => {},
  onClickCancel = e => {},
  onClose = e => {},
  canEdit,
  canDelete,
  canCancel,
  isEditable,
  status,
  ...root
}) => {
  const settings = useContext(SettingsContext)
  const {selectedViewGroup} = useCalendarViewContext()
  const [reservation, dispatch] = useGetReservationItemDetails()
  return (
    <Menu
      onClose={onClose}
      getContentAnchorEl={null}
      anchorOrigin={{
        horizontal: 'right',
        vertical: 'bottom',
      }}
      transformOrigin={{
        horizontal: 'right',
        vertical: 'top',
      }}
      PaperProps={{
        style: {
          minWidth: '192px',
        },
      }}
      style={{transformOrigin: 'center top'}}
      keepMounted
      {...root}
    >
      <div>
        {canEdit && isEditable && (
          <MenuItem onClick={e => onClickEdit(e)} className="font-13 font-color">
            Edit
          </MenuItem>
        )}
      </div>
      <div>
        {canCancel && status !== 'fulfilled' && (
          <MenuItem onClick={e => onClickCancel(e)} className="font-13 font-color">
            Cancel
          </MenuItem>
        )}
      </div>
      <div>
        {canDelete && (
          <MenuItem onClick={e => onClickDelete(e)} className="font-13 font-color">
            Delete
          </MenuItem>
        )}
      </div>
    </Menu>
  )
}

export default MenuMore
